const PathName = {
  ManuePage: "/:lang/",
  LoginPage: "/:lang/login",
  CategoryPage: "/:lang/menu",
  ProductPage: "/:lang/product-Page",
  AboutUs: "/:lang/about-us/:theme?",
  PrivacyPolicy: "/:lang/privacy-policy/:theme?",
  TermsAndConditions: "/:lang/terms-condition/:theme?",
  // MitaoBhook: "/:lang/mitao-Bhook/:theme?",
  CareersPage: "/:lang/careers-page/:theme?",
  ContactUs: "/:lang/contact-Us",
  Bucket: "/:lang/bucket",
  ProfilePage: "/:lang/profile-Page",
  PaymentMethod: "/:lang/payment-method",
  MobilePaymentMethod: "/:lang/mobile-card",
  StoreLocator: "/:lang/store-locations",
  TrackOrder: "/:lang/track-order",
  Item: "/:lang/item",
  OrderHistory: "/:lang/order-history",
  FeedBack: "/:lang/feedBack",
  AddFavorite: "/:lang/your-favourites-items",
  SaveAddress: "/:lang/myaddress",
  SaveCards: "/:lang/mycards",
  MyDetail: "/:lang/my-details",
  // MitaoBhookScholarship: "/:lang/mitao-bhook-scholarship/:theme?",
  GuestLogin: "/:lang/details",
  SignUp: "/:lang/sign-up",
  ChangePassword: "/:lang/change-password",
  RateUS: "/:lang/rate-us",
  CampaignRedirection: "/:lang/campaign-redirection",
  DineinRedirection: "/:lang/dinein",
};

export default PathName;
